import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'context/SettingsContext';
import { Badge } from 'react-bootstrap';
import { DateTime as DT } from 'luxon';
import type { DirLeadStatusType } from '@econtractor/types';
import vconst from 'utils/helpers/structs/vconst';
import { tDirName } from 'utils/helpers/i18n/tDirName';
import { getLocale } from 'utils/helpers/functions/getLocale';
import SolarIcon from 'components/icons/SolarIcon';

interface LeadStatusProps {
    leadStatus?: number;
    /** Дата «перенесено до» (millis) — показується під статусом 350 */
    leadPendingDt?: number | null;
    /** Клас для Badge (за замовчуванням fs-12) */
    className?: string;
}

const LeadStatus = ({ leadStatus = 0, leadPendingDt, className = 'fs-12' }: LeadStatusProps) => {
    const { t, i18n } = useTranslation(['Leads']);
    const { localSettings } = useSettings();

    const dirStatus = localSettings?.DIRS?.LeadStatus?.find(
        (l: DirLeadStatusType) => l.ID == leadStatus,
    );
    const getStatusStyle = () => dirStatus?.statusJson?.statusStyle || 'danger';

    const [statusStyle, setStatusStyle] = useState(getStatusStyle());

    useEffect(() => {
        setStatusStyle(getStatusStyle());
    }, [leadStatus, localSettings]);

    const pendingDt = Number(leadPendingDt || 0);
    const showPendingDt = leadStatus === vconst.leadPostponed && pendingDt > 0;
    const pendingLabel = showPendingDt
        ? DT.fromMillis(pendingDt, { zone: 'local' })
            .setLocale(getLocale(i18n.language))
            .toLocaleString(DT.DATE_MED)
        : '';
 
    return (
        <div className="lead-status">
            <Badge bg={statusStyle} className={className}>
                {tDirName(t, dirStatus?.i18nKey, dirStatus?.statusName) || t(`status.${leadStatus || 0}`)}
            </Badge>
            {showPendingDt ? (
                <span className="lead-status__pending" title={t('leadStatus.labelPendingDt')}>
                    <SolarIcon name="calendar3" aria-hidden="true" />
                    {pendingLabel}
                </span>
            ) : null}
        </div>
    );
};

export default LeadStatus;
